import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
          >
            <span className="font-heading text-2xl font-bold text-primary-500">
              韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {comicCategories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 rounded-md transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/all"
              className="px-3 py-2 text-sm font-medium text-secondary-500 hover:text-primary-500 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              更多分类
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors duration-200 whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {comicCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200/70 my-1"></div>
            <Link
              to="/about"
              className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors"
            >
              <i className="ri-information-line text-base"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}